
// Actions
const PREFIX = 'calculus/customs/';

export const SET_CUSTOMS_ITEMS  = PREFIX + 'SET_CUSTOMS_ITEMS';
export const PATCH_CUSTOMS_ITEMS  = PREFIX + 'PATCH_CUSTOMS_ITEMS';
export const REMOVE_CUSTOMS_ITEMS  = PREFIX + 'REMOVE_CUSTOMS_ITEMS';

import { PRODUCTS } from './products';
import { CLADDING } from './claddings';
import { ENERGY } from './energy';
import { MEDIUMS } from './mediums';
import { MATERIALS } from './materials';

export function getCustomArrayName(data) {
  switch(data.type) {
    case PRODUCTS:
      return 'products';
    case CLADDING:
      return 'claddings';
    case ENERGY:
      return 'energy';
    case MEDIUMS:
      return 'mediums';
    case MATERIALS:
      return 'materials';
  }
}

export function getType(data) {
  switch(data.type) {
    case PRODUCTS:
      return 'product';
    case CLADDING:
      return 'cladding';
    case ENERGY:
      return 'energy';
    case MEDIUMS:
      return 'medium';
    case MATERIALS:
      return 'material';
  }
}

export function parseItems(items, type) {
  const parsedItems = items.data.filter( item => {
    return item &&
           item.attributes &&
           item.attributes.itemtype &&
           item.attributes.itemtype === type;
  });

  return parsedItems.map( item => {
    return {
      uuid: item.id,
      ...item.attributes,
      ...JSON.parse(item.attributes.data.value)
    };
  });
}

export function parseItem(item, type) {
  let parsedItem;
  if(item && item.attributes && item.attributes.itemtype && item.attributes.itemtype === type) {
    return {
      uuid: item.id,
      ...item.attributes,
      ...JSON.parse(item.attributes.data.value)
    };
  }
  return null;
}

const INITIAL_STATE = {

};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_CUSTOMS_ITEMS:
      return {

      };

    default:
      return state;
  }
}

// Action Creators
export function setCustomItems(payload) {
  return {
    type: SET_CUSTOMS_ITEMS,
    payload: payload
  };
}

export function patchCustomItems(payload) {
  return {
    type: PATCH_CUSTOMS_ITEMS,
    payload: payload
  };
}

export function removeCustomItems(payload) {
  return {
    type: REMOVE_CUSTOMS_ITEMS,
    payload: payload
  };
}
